module.exports = __webpack_public_path__ + "static/img/HM.805dc060.svg";